import { SIG } from "../../common/apiUrl/sig/sigUrls";
import { API } from "../../common/model/objectTypes";
import { archivedSignatureInfo } from "../../utils/apiDescription/sig/archivedSignature";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { archivedAPIresendAccessLinkRequestBody, getArchivedSignatureRequestParameter, getArchivedSignatureResponseBody, getSignerDetailRequestParameter, getSignerDetailsResponseBody, sendReminderRequestBody, SIG_Archived_GetAccessLinkRequestParameter, SIG_Archived_GetAccessLinkResponseBody, sigBaseRequestBody } from "../../utils/sig/apiObject";
import { archiveAPIdeleteSignatureJsonRequestCurl, archiveAPIresendAccessLinkJsonRequestCurl, archiveAPIrestoreSignatureJsonRequestCurl, archivedAPIsendReminderJsonRequestCurl, getArchivedSignatureJsonRequestCurl, getSignerDetailJsonRequestCurl, SIG_Archived_GetAccessLinkRequestCurl } from "../../utils/sig/sampleJsonRequest";
import { getArchivedSignatureJsonResponse, getSignerDetailJsonResponse, SIG_Archived_GetAccessLinkJsonResponse } from "../../utils/sig/sampleJsonResponse";

const All: API = {
    name: "Archived Signatures",
    url: `${API_BASE_URL}/${SIG.ARCHIVED.GET_ARCHIVED_SIGNATURES_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: archivedSignatureInfo.archivedSignature,
    requestBody: getArchivedSignatureRequestParameter,
    responseBody: getArchivedSignatureResponseBody,
    jsonRequest: getArchivedSignatureJsonRequestCurl,
    jsonResponse: getArchivedSignatureJsonResponse,
}

const getSignerDetails: API = {
    name: "Signer Details",
    url: `${API_BASE_URL}/${SIG.ARCHIVED.GET_SINGER_DETAIL_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: archivedSignatureInfo.getSignerDetails,
    requestBody: getSignerDetailRequestParameter,
    responseBody: getSignerDetailsResponseBody,
    jsonRequest: getSignerDetailJsonRequestCurl,
    jsonResponse: getSignerDetailJsonResponse,
}

const deleteSignature: API = {
    name: "Delete Signature",
    url: `${API_BASE_URL}/${SIG.ARCHIVED.DELETE_SIGNATURE_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: archivedSignatureInfo.deleteSignature,
    requestBody: sigBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: archiveAPIdeleteSignatureJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const resendAccessLink: API = {
    name: "Resend Access Link",
    url: `${API_BASE_URL}/${SIG.ARCHIVED.RESEND_ACCESS_LINK_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: archivedSignatureInfo.resendAccessLink,
    requestBody: archivedAPIresendAccessLinkRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: archiveAPIresendAccessLinkJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const restoreSignature: API = {
    name: "Restore Signature API",
    url: `${API_BASE_URL}/${SIG.ARCHIVED.RESTORE_SIGNATURE_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: archivedSignatureInfo.restoreSignature,
    requestBody: sigBaseRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: archiveAPIrestoreSignatureJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}

const sendReminder: API = {
    name: "Send Reminder API",
    url: `${API_BASE_URL}/${SIG.ARCHIVED.SEND_REMINDER_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: archivedSignatureInfo.sendReminder,
    requestBody: sendReminderRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: archivedAPIsendReminderJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}

const accessLink: API = {
    name: "Access Link",
    url: `${API_BASE_URL}/${SIG.ARCHIVED.GET_ACCESS_LINK_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: archivedSignatureInfo.getAccessLink,
    requestBody: SIG_Archived_GetAccessLinkRequestParameter,
    responseBody: SIG_Archived_GetAccessLinkResponseBody,
    jsonRequest: SIG_Archived_GetAccessLinkRequestCurl,
    jsonResponse: SIG_Archived_GetAccessLinkJsonResponse,
}


export const getContent = (apiName: string) => {
    switch (apiName) {
        case 'All':
            return All;
        case 'Signer Details':
            return getSignerDetails;
        case 'Archived Signature':
            return deleteSignature;
        case 'Resend Access Link':
            return resendAccessLink;
        case 'Restore':
            return restoreSignature;
        case 'Send Reminder':
            return sendReminder;
        case 'Access Link':
            return accessLink;
    }
}